import type { ErrorEvent, EventHint } from "@sentry/angular";

const message_blacklist = [
  /ExpressionChangedAfterItHasBeenCheckedError/i,
  /_jp[.].* is not a function/i,
];

export function onSentryBeforeSend(event: ErrorEvent, hint: EventHint) {
  const error = hint.originalException as Error;
  if (
    error &&
    error.message &&
    message_blacklist.findIndex((x) => error.message.match(x)) >= 0
  ) {
    return null;
  }
  return event;
}
